import type { StackProps } from "@/core/components/ui/stack";
import { Stack } from "@/core/components/ui/stack";
import { cn } from "@/core/utils/utils";

interface PayBreakdownPaneShellProps extends Omit<StackProps, "fullWidth"> {
  fillHeight?: boolean;
  variant?: "pane" | "page";
}

export const PayBreakdownPaneShell = ({
  className,
  fillHeight = false,
  gap = "md",
  variant = "pane",
  ...props
}: PayBreakdownPaneShellProps) => (
  <Stack
    fullWidth
    gap={gap}
    className={cn(
      "mx-auto w-full max-w-[1680px]",
      {
        "min-h-0 flex-1": fillHeight,
        "px-4 pb-8 sm:px-6 lg:px-8 2xl:px-10": variant === "pane",
        "px-8 py-6": variant === "page",
      },
      className,
    )}
    {...props}
  />
);
